
<template lang="html">
    <div class="layout--main" >
      <template >
      <the-navbar-vertical-inmobiliaria/>
    </template>
    <!-- /Navbar -->

      <div class="">

        <div class="router-view">
          <div class="router-content">

              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

                <!-- DROPDOWN -->
                <vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer">
                  <vs-button radius icon="icon-settings" icon-pack="feather" />

                  <vs-dropdown-menu class="w-32">
                    <vs-dropdown-item>
                      <div @click="$router.push('/pages/profile').catch(() => {})" class="flex items-center">
                        <feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Profile</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div @click="$router.push('/apps/todo').catch(() => {})" class="flex items-center">
                        <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Tasks</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div @click="$router.push('/apps/email').catch(() => {})" class="flex items-center">
                        <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Inbox</span>
                      </div>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>

                </vs-dropdown>

              </div>

            <div class="perfil-margin">
                <div id="casos">
    <div class="">
      <div class="vx-row">
       
        <!--<div class="vx-col lg:w-1/5 sm:w-full">
          <button class="btn btn-primary"   to="/nuevaCotizacionInmobiliaria">Simula un crédito</button>
          <br>
        </div>-->

         <div class="vx-col lg:w-1/5 sm:w-full">
          <button class="btn btn-primary"  @click="IrSimulad()" >Simula un crédito</button>
          <br>
        </div>
        <!--
        <div class="vx-col lg:w-1/5 sm:w-full">
          <ul class="centerx">
            <li>
              <vs-radio v-model="filtroCasos" vs-value="1">Solo mis casos</vs-radio>
            </li>
            <li>
              <vs-radio v-model="filtroCasos" vs-value="2">Los casos de mis supervisados</vs-radio>
            </li>
          </ul>
          <br>
        </div>-->

          
        
       <!-- <div class="vx-col lg:w-1/5 sm:w-full">
          <div>
            <span class="span-placeholder" for="estatus">Filtrar por estatus</span>
            <select name="cars" id="estatus" v-model="estatu" class="vs-input">
              <option :value='tipo.Id' v-for="tipo in socStatus"  :key="">{{tipo.Nombre}}</option>
            </select>
          </div>
        </div>-->
      </div>
    </div>
    <br>
    <!--<p >Busca por Folio, ejecutivo, cliente o destino</p>-->
    <vs-table :data="casos" max-items="10"
     search
      pagination
      noDataText="No hay datos para mostrar"
      class="tabla">
      <template slot="header">
        <div class="col-md-2">
        <h3>
          Lista de casos
        </h3>
        </div>
  <!--<div class="row w-full">
          <div class="col-md-4">
            <div class="alinear flex-nowrap">
              <span class="lupa" id="addon-wrapping">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <g id="vuesax_twotone_filter-search" data-name="vuesax/twotone/filter-search" transform="translate(-492 -701)">
                    <g id="filter-search">
                      <path id="Vector" d="M11.01,17.06a2.246,2.246,0,0,1-.91,1.72l-1.41.91a2.058,2.058,0,0,1-3.13-1.72V12.62a3.834,3.834,0,0,0-.81-2.12L.91,6.46A3.323,3.323,0,0,1,0,4.44V2.12A2.051,2.051,0,0,1,2.02,0H15.36a2.027,2.027,0,0,1,2.02,2.02V4.24a3.773,3.773,0,0,1-1.01,2.32" transform="translate(495.31 703.01)" fill="none" stroke="#26558f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" opacity="0.4"/>
                      <g id="Group">
                        <path id="Vector-2" data-name="Vector" d="M6.4,3.2A3.2,3.2,0,1,1,3.2,0,3.2,3.2,0,0,1,6.4,3.2Z" transform="translate(504.87 711.12)" fill="none" stroke="#26558f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                        <path id="Vector-3" data-name="Vector" d="M1,1,0,0" transform="translate(510.87 717.12)" fill="none" stroke="#26558f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                      </g>
                      <path id="Vector-4" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(516 725) rotate(180)" fill="none" opacity="0"/>
                    </g>
                  </g>
                </svg>
              </span>
              <select name="cars" id="estatus" v-model="estatu" class="search-input vs-input3" placeholder="Filtrar por estatus"  aria-label="Username" aria-describedby="addon-wrapping" style="boder:none;">
              <option :value='tipo.Id' v-for="tipo in socStatus"  :key="">{{tipo.Nombre}}</option>
            </select>
          </div>
          </div>
          </div>-->
          <div class="row w-full">
            <div class="col-md-4">
              </div>
          </div>    
          <div class="col-md-2">
            <select  v-model="filtroCasos" class="vs-input2" placeholder="Filtrar casos"  aria-label="Username" aria-describedby="addon-wrapping" style="boder:none;">
             
              <option :value="1">Solo mis casos</option>
              <option :value="2">Los casos de mis supervisados</option>
              <option :value="3">Digital</option>
            </select>

            </div>
      </template>
      <template slot="thead">
        <vs-th sort-key="Folio">
          Folio
        </vs-th>
        <vs-th>
          Fecha ingreso
        </vs-th>
        <vs-th v-if=" filtroCasos!='1'">
          Ejecutivo
        </vs-th>
        <vs-th sort-key="Cliente">
          Cliente
        </vs-th>
        <vs-th >
          Correo
        </vs-th>
        <vs-th >
          Teléfono
        </vs-th>
        <vs-th>
          Destino
        </vs-th>
        <vs-th>
          Crédito
        </vs-th>
       <!-- <vs-th v-if=" filtroCasos=='3'">

        </vs-th>
        <vs-th v-if=" filtroCasos=='2'">
          Origen
        </vs-th>
				<vs-th v-if=" filtroCasos!='1'">
          Organización
        </vs-th>-->
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"  :class="data[indextr].StatusCaso == 'Nuevo' && filtroCasos== '3'?'colorNuevo':''">
          <vs-td  :data="data[indextr].Id" >
            <a @click="handleSelected(data[indextr].Id)">{{data[indextr].Id}}</a>
          </vs-td>
          <vs-td :data="data[indextr].Fecha">
            <a @click="handleSelected(data[indextr].Id)">{{data[indextr].Fecha}}</a>
          </vs-td>
          <vs-td v-if=" filtroCasos!='1'" :data="data[indextr].BrokerNombre">
            <a @click="handleSelected(data[indextr].Id)">{{data[indextr].BrokerNombre}}</a>
          </vs-td>
          <vs-td :data="data[indextr].SolicitanteNombre">
            <a @click="handleSelected(data[indextr].Id)">{{data[indextr].SolicitanteNombre}}</a>
          </vs-td>
          <vs-td :data="data[indextr].Solicitante">
            <a :href="'mailto:' + data[indextr].Solicitante" class="contact-bold">{{data[indextr].Solicitante}}</a>
            
          </vs-td>
          <vs-td :data="data[indextr].SolicitanteTelefonoCelular">
            <a :href="'https://api.whatsapp.com/send?phone='+data[indextr].Lada+data[indextr].SolicitanteTelefonoCelular.replace(/\s+/g, '').replace(/-/g, '')" rel="noopener" target="_blank"  class="contact-bold">{{data[indextr].SolicitanteTelefonoCelular}}</a>
          </vs-td>
          <vs-td :data="data[indextr].Destino">
            <a @click="handleSelected(data[indextr].Id)">{{data[indextr].DestinoNombre}}</a>
          </vs-td>
          <vs-td :data="data[indextr].MontoSolicitado">
            <a @click="handleSelected(data[indextr].Id)">${{data[indextr].MontoSolicitado}}</a>
          </vs-td>
         <!-- <vs-td v-if="data[indextr].StatusCaso == 'Nuevo' && filtroCasos=='3'" :data="data[indextr].StatusCaso" style="color:#079DEF">
            {{data[indextr].StatusCaso}}
          </vs-td>

          <vs-td v-if="data[indextr].StatusCaso == 'Abierto' && filtroCasos=='3'" :data="data[indextr].StatusCaso" style="color:#079DEF">
            
          </vs-td>

          <vs-td v-if=" filtroCasos=='2'" :data="data[indextr].VersionOrigen" style="font-weight:bold">
            {{data[indextr].VersionOrigen}}
          </vs-td>

          

          
          
          <vs-td v-if=" filtroCasos!='1'" :data="data[indextr].Organizacion">
            {{data[indextr].Organizacion}}
          </vs-td>-->
        </vs-tr>
      </template>
    </vs-table>
    <div class="excel">
      <button @click="activePrompt=true;popupActive=false;"  class="btn btn-exportar mt-4" >
        <svg xmlns="http://www.w3.org/2000/svg" width="29.871" height="29.871" viewBox="0 0 29.871 29.871">
          <g id="vuesax_twotone_login" data-name="vuesax/twotone/login" transform="translate(-300 -444)">
            <g id="login" transform="translate(300 444)">
              <g id="Group_649" data-name="Group 649" transform="translate(4.979 11.824)">
                <path id="Vector" d="M0,6.372,3.186,3.186,0,0" transform="translate(9.558)" fill="none" stroke="#26558f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                <path id="Vector-2" data-name="Vector" d="M0,0H12.658" transform="translate(0 3.186)" fill="none" stroke="#26558f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
              </g>
              <path id="Vector-3" data-name="Vector" d="M0,0C5.5,0,9.957,3.734,9.957,9.957S5.5,19.914,0,19.914" transform="translate(14.936 4.979)" fill="none" stroke="#26558f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" opacity="0.4"/>
              <path id="Vector-4" data-name="Vector" d="M0,0H29.871V29.871H0Z" transform="translate(29.871 29.871) rotate(180)" fill="none" opacity="0"/>
            </g>
          </g>
        </svg> <strong>Exportar a tabla de Excel</strong>
      </button>
      <vs-prompt title="Exporar a Excel" class="export-options" cancel-text="Cancelar" @cancle="clearFields" @accept="exportToExcel" accept-text="Exportar" @close="clearFields" :active.sync="activePrompt">
              <input type="text" v-model="fileName" placeholder="Nombre del archivo" class="vs-input" />
              <v-select v-model="selectedFormat" :options="formats" class="my-4" />
              <div class="flex">
                <span class="mr-4">Tamaño de la celda automático:</span>
                <vs-switch v-model="cellAutoWidth">Tamaño automático</vs-switch>
              </div>
      </vs-prompt>
    </div>
 </div>
            </div>
          </div>
        </div>
      </div>
 <div class="footer">COPYRIGHT 2021 Cotizador SOC, todos los derechos reservados.</div>    </div>
</div>
   <!-- <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" >
        <vs-tabs alignment="fixed">
          <vs-tab label="Generales" @click="updateStatusSIsec('Generales')" >
            <div>
              <p class="float-right label-search" style="margin-bottom:-5%">Busca por Folio, cliente o email del cliente</p>
                <vs-table :data="casos" max-items="10"
                pagination
                search
                v-model="selected"
               
                noDataText="No hay datos para mostrar"
                class="tabla">
                
                <template slot="thead">
                    <vs-th sort-key="Folio">
                    Folio
                    </vs-th>
                    <vs-th>
                    Fecha ingreso
                    </vs-th>
                    <vs-th sort-key="Cliente">
                    Cliente
                    </vs-th>
                            <vs-th>
                    Destino
                    </vs-th>
                    <vs-th>
                    Crédito
                    </vs-th>
                     <vs-th>
                    Valor de la vivienda
                    </vs-th>
                    <vs-th>
                    Consulta buro
                    </vs-th>
                    <vs-th hidden sort-key="Solicitante"></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].Id" >
                        {{data[indextr].Id}}
                    </vs-td>

                  

                    <vs-td :data="data[indextr].Fecha">
                        {{data[indextr].Fecha}}
                    </vs-td>

                    <vs-td :data="data[indextr].SolicitanteNombre">
                        {{data[indextr].SolicitanteNombre}}
                    </vs-td>
                    <vs-td :data="data[indextr].Destino">
                        {{data[indextr].DestinoNombre}}
                    </vs-td>
                    <vs-td :data="data[indextr].MontoSolicitado">
                        ${{data[indextr].MontoSolicitado}}
                    </vs-td>
                    <vs-td :data="data[indextr].ValorInmueble">
                        ${{data[indextr].ValorInmueble}}
                    </vs-td>
                    <vs-td :data="data[indextr].AutorizaConsultaBuro">
                        {{data[indextr].AutorizaConsultaBuro}}
                    </vs-td>
                    <vs-td :data="data[indextr].Solicitante" hidden>
                        {{data[indextr].Solicitante}}
                    </vs-td>    
                    </vs-tr>
                </template>
                </vs-table>
            </div>
          </vs-tab>
          <vs-tab label="En proceso" @click="updateStatusSIsec('En proceso')">
            <div>
             <p class="float-right label-search" style="margin-bottom:-5%">Busca por Folio, cliente o email del cliente</p>
                <vs-table :data="casos" max-items="10"
                pagination
                search
                v-model="selected"
               
                noDataText="No hay datos para mostrar"
                class="tabla">
               
                <template slot="thead">
                    <vs-th sort-key="Folio">
                    Folio
                    </vs-th>
                    <vs-th>
                    Fecha ingreso
                    </vs-th>
                    <vs-th sort-key="Cliente">
                    Cliente
                    </vs-th>
                            <vs-th>
                    Destino
                    </vs-th>
                    <vs-th>
                    Crédito
                    </vs-th>
                     <vs-th>
                    Valor de la vivienda
                    </vs-th>
                    <vs-th>
                    Consulta buro
                    </vs-th>
                    <vs-th hidden sort-key="Solicitante"></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].Id" >
                        {{data[indextr].Id}}
                    </vs-td>

                  

                    <vs-td :data="data[indextr].Fecha">
                        {{data[indextr].Fecha}}
                    </vs-td>

                    <vs-td :data="data[indextr].SolicitanteNombre">
                        {{data[indextr].SolicitanteNombre}}
                    </vs-td>
                    <vs-td :data="data[indextr].Destino">
                        {{data[indextr].DestinoNombre}}
                    </vs-td>
                    <vs-td :data="data[indextr].MontoSolicitado">
                        ${{data[indextr].MontoSolicitado}}
                    </vs-td>
                    <vs-td :data="data[indextr].ValorInmueble">
                        ${{data[indextr].ValorInmueble}}
                    </vs-td>
                    <vs-td :data="data[indextr].AutorizaConsultaBuro">
                        {{data[indextr].AutorizaConsultaBuro}}
                    </vs-td>
                    <vs-td :data="data[indextr].Solicitante" hidden>
                        {{data[indextr].Solicitante}}
                    </vs-td>
                    </vs-tr>
                </template>
                </vs-table>
            </div>
          </vs-tab>
          <vs-tab label="Firmados" @click="updateStatusSIsec('Firmados')">
            <div>
             <p class="float-right label-search" style="margin-bottom:-5%">Busca por Folio, cliente o email del cliente</p>
                <vs-table :data="casos" max-items="10"
                pagination
                search
                v-model="selected"
                
                noDataText="No hay datos para mostrar"
                class="tabla">

                <template slot="thead">
                    <vs-th sort-key="Folio">
                    Folio
                    </vs-th>
                    <vs-th>
                    Fecha ingreso
                    </vs-th>
                    <vs-th sort-key="Cliente">
                    Cliente
                    </vs-th>
                            <vs-th>
                    Destino
                    </vs-th>
                    <vs-th>
                    Crédito
                    </vs-th>
                     <vs-th>
                    Valor de la vivienda
                    </vs-th>
                    <vs-th>
                    Consulta buro
                    </vs-th>
                    <vs-th hidden sort-key="Solicitante"></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].Id" >
                        {{data[indextr].Id}}
                    </vs-td>


                    <vs-td :data="data[indextr].Fecha">
                        {{data[indextr].Fecha}}
                    </vs-td>

                    <vs-td :data="data[indextr].SolicitanteNombre">
                        {{data[indextr].SolicitanteNombre}}
                    </vs-td>
                    <vs-td :data="data[indextr].Destino">
                        {{data[indextr].DestinoNombre}}
                    </vs-td>
                    <vs-td :data="data[indextr].MontoSolicitado">
                        ${{data[indextr].MontoSolicitado}}
                    </vs-td>
                    <vs-td :data="data[indextr].ValorInmueble">
                        ${{data[indextr].ValorInmueble}}
                    </vs-td>
                    <vs-td :data="data[indextr].AutorizaConsultaBuro">
                        {{data[indextr].AutorizaConsultaBuro}}
                    </vs-td>
                    <vs-td :data="data[indextr].Solicitante" hidden>
                        {{data[indextr].Solicitante}}
                    </vs-td>
                    </vs-tr>
                </template>
                </vs-table>
            </div>
          </vs-tab>
          <vs-tab label="Descartados" @click="updateStatusSIsec('Descartados')">
            <div>
            <p class="float-right label-search" style="margin-bottom:-5%">Busca por Folio, cliente o email del cliente</p>
                <vs-table :data="casos" max-items="10"
                pagination
                search
                v-model="selected"
                
                noDataText="No hay datos para mostrar"
                class="tabla">

                <template slot="thead">
                    <vs-th sort-key="Folio">
                    Folio
                    </vs-th>
                    <vs-th>
                    Fecha ingreso
                    </vs-th>
                    <vs-th sort-key="Cliente">
                    Cliente
                    </vs-th>
                            <vs-th>
                    Destino
                    </vs-th>
                    <vs-th>
                    Crédito
                    </vs-th>
                     <vs-th>
                    Valor de la vivienda
                    </vs-th>
                    <vs-th>
                    Consulta buro
                    </vs-th>
                    <vs-th hidden sort-key="Solicitante"></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].Id" >
                        {{data[indextr].Id}}
                    </vs-td>



                    <vs-td :data="data[indextr].Fecha">
                        {{data[indextr].Fecha}}
                    </vs-td>

                    <vs-td :data="data[indextr].SolicitanteNombre">
                        {{data[indextr].SolicitanteNombre}}
                    </vs-td>
                    <vs-td :data="data[indextr].Destino">
                        {{data[indextr].DestinoNombre}}
                    </vs-td>
                    <vs-td :data="data[indextr].MontoSolicitado">
                        ${{data[indextr].MontoSolicitado}}
                    </vs-td>
                    <vs-td :data="data[indextr].ValorInmueble">
                        ${{data[indextr].ValorInmueble}}
                    </vs-td>
                    <vs-td :data="data[indextr].AutorizaConsultaBuro">
                        {{data[indextr].AutorizaConsultaBuro}}
                    </vs-td>
                    <vs-td :data="data[indextr].Solicitante" hidden>
                        {{data[indextr].Solicitante}}
                    </vs-td>
                    </vs-tr>
                </template>
                </vs-table>
            </div>
          </vs-tab>
         
        </vs-tabs>
      </vs-col>-->
    
 
</template>

<script>
import TheNavbarVerticalInmobiliaria   from '@/layouts/components/navbar/TheNavbarVerticalInmobiliaria.vue'

import md5 from 'js-md5';
import vSelect from 'vue-select'
export default {
  props: {
    guid: {
      type: String,
      required: false
    },
  },
  components: {
    TheNavbarVerticalInmobiliaria,
    'v-select': vSelect,
  },
  data(){
		return{
      filtroCasos:'1',
      key:'',
			casos:[],
        casoGenerales:[],
        casoEnProceso:[],
        casoFirmados:[],
        casoDescartados:[],
      allcasos:[],
			estatus:[],
			destinos:[],
      selected:[],
      estatu:'',
      socData:null,
      socStatus:[],
      fileName: '',
      formats:['xlsx', 'csv', 'txt'],
      cellAutoWidth: true,
      selectedFormat: 'xlsx',
      headerTitle: ['Folio', 'Ejecutivo', 'Fecha Ingreso', 'Cliente','Correo','Telefono', 'Estatus','Destino','Credito'],
      headerVal: ['Id', 'BrokerNombre', 'Fecha', 'SolicitanteNombre', 'Solicitante', 'Telefono', 'EstatusNombre','DestinoNombre','MontoSolicitado'],
      popupActive: false,
      activePrompt: false,
      StatusSisecTabs:'Generales',
      inmobiliaria : false,
      soc:false
		}
  },
	mounted(){
    if(!JSON.parse(localStorage.getItem('userInfo'))){
      this.$router.push('/login').catch(() => {})
    }else {
      this.getApikey()
      this.getSolicitudes()
      this.getDestinos()
      this.getEstatus()
    }

    if (this.$store.state.AppActiveUser.WidgetColorPrimario != '' && this.$store.state.AppActiveUser.WidgetColorPrimario) {
      this.$vs.theme({
        primary:this.$store.state.AppActiveUser.WidgetColorPrimario
      })
    }

    this.$vs.loading({
      container: '#casos',
      scale: 0.6
    })
	},
  watch: {
    filtroCasos: function() {
      this.$vs.loading({
        container: '#casos',
        scale: 0.6
      })
      /*if (this.filtroCasos == '1') {
        this.getSolicitudes()
      }else if(this.filtroCasos == '2'){
        this.getCasosSolicitados('Generales')
      }else if(this.filtroCasos == '3'){
        this.getCasosWidget()
      }*/
       if (this.filtroCasos == '1') {
        this.getSolicitudes()
      }else if(this.filtroCasos == '2'){
        this.getCasosSolicitados()
      }else if(this.filtroCasos == '3'){
        this.getCasosWidget()
      }
    },
    estatu: function() {
      if (this.estatu == null) {
        this.casos= this.allcasos
      }else {
        this.filter(this.estatu)
      }
    }
  },
	methods:{
    handleSelected(tr) {
      this.$router.push('/casoInmobiliaria/'+tr).catch(() => {})
    },
    filter(id){ //No se ocupa en inmobiliaria
      var newArray = this.allcasos.filter(function (el) {
        return el.Estatus == id;
      });
      this.casos=newArray
    },
    getApikey(){
      this.key=JSON.parse(localStorage.getItem('userInfo')).ApiKey;
    },
    IrSimulad() {
      //alert('hoal')
			this.$router.push('/nuevaCotizacionInmobiliaria').catch(() => {})
		},
		getDestinos(){
      let self=this
			var objRequestListaDestinos = {
				strApiKey: this.key,
				strMetodo: 'ListaDestinos',
			}
			this.$axios.post('/',objRequestListaDestinos,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
			.then(
				response => {
					if(response.data.intEstatus == 0){
						this.destinos=response.data.objContenido
					}else {
            this.$vs.notify({
              title:'Ocurrio un error en ListaDestinos',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
				}
			).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
			})
		},
		getEstatus(){
      let self=this
			var objRequestListaCasoEstatus = {
				strApiKey: this.key,
				strMetodo: 'ListaCasoEstatus',
			}
			this.$axios.post('/',objRequestListaCasoEstatus,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
			.then(
				response => {
					if(response.data.intEstatus == 0){
						this.estatus=response.data.objContenido
            this.estatus.sort((a,b) => (a.Id > b.Id) ? 1 : ((b.Id > a.Id) ? -1 : 0));
            for (var i = 0; i < this.estatus.length; i++) {
              if (this.estatus[i].Id== 1 || this.estatus[i].Id== 2 || this.estatus[i].Id== 3 || this.estatus[i].Id== 5 || this.estatus[i].Id== 11) {
                this.socStatus.push(this.estatus[i])
                this.socStatus.sort((a,b) => (a.Id > b.Id) ? 1 : ((b.Id > a.Id) ? -1 : 0));
              }
            }
					}else {
            this.$vs.notify({
              title:'Ocurrio un error en ListaCasoEstatus',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
				}
			).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
			})
		},
    getCasosSolicitados(){
      let self=this
			var objRequestListaCasos = {
				strApiKey: this.key,
				strMetodo: 'ListaCasosJerarquiaInmobiliaria',
        objParametros: {
           Limite:900,
           strStatus:this.StatusSisecTabs
       }
			}
			this.$axios.post('/',objRequestListaCasos,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
			.then(
				response => {
					if(response.data.intEstatus == 0){
            this.casos= response.data.objContenido
            this.allcasos=this.casos

						for (var i = 0; i < this.casos.length; i++) {
							this.casos[i].MontoSolicitado= this.casos[i].MontoSolicitado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							for (var j = 0; j < this.destinos.length; j++) {
								if (this.destinos[j].Id == this.casos[i].Destino) {
										this.casos[i].DestinoNombre=(this.destinos[j].Nombre).toLowerCase()
								}
							}
							for (var k = 0; k < this.estatus.length; k++) {
								if (this.estatus[k].Id == this.casos[i].Estatus) {
										this.casos[i].EstatusNombre=(this.estatus[k].Nombre).toLowerCase()
								}
							}
                            if(this.casos[i].AutorizaConsultaBuro  == null){
                                this.casos[i].AutorizaConsultaBuro='No'
                            }else{
                                this.casos[i].AutorizaConsultaBuro='Si'
                            }
						}
					}else {
            this.$vs.notify({
              title:'Ocurrio un error en ListaCasos',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
          this.$vs.loading.close('#casos > .con-vs-loading')
				}
			).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
			})
    },
    updateStatusSIsec(statusSisec){
        this.StatusSisecTabs=statusSisec
        this.$vs.loading({
        container: '#casos',
        scale: 0.6
      })
      if (this.filtroCasos == '1') {
        this.getSolicitudes()
      }else if(this.filtroCasos == '2'){
        this.getCasosSolicitados('Generales')
      }else if(this.filtroCasos == '3'){
        this.getCasosWidget()
      }
    },
		/*getSolicitudes(){
            
      let self=this
			var objRequestListaCasos = {
				strApiKey: this.key,
				strMetodo: 'ListaCasosInmobiliaria',
                objParametros: {
                    ApiKey:this.key,
                    strStatus:this.StatusSisecTabs
                }
			}
			this.$axios.post('/',objRequestListaCasos,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
			.then(
				response => {
					if(response.data.intEstatus == 0){
                        this.casos= response.data.objContenido
                        this.allcasos=this.casos
						for (var i = 0; i < this.casos.length; i++) {
							this.casos[i].MontoSolicitado= this.casos[i].MontoSolicitado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							for (var j = 0; j < this.destinos.length; j++) {
								if (this.destinos[j].Id == this.casos[i].Destino) {
										this.casos[i].DestinoNombre=(this.destinos[j].Nombre).toLowerCase()
								}
							}
							for (var k = 0; k < this.estatus.length; k++) {
								if (this.estatus[k].Id == this.casos[i].Estatus) {
										this.casos[i].EstatusNombre=(this.estatus[k].Nombre).toLowerCase()
								}
							}
                            if(this.casos[i].AutorizaConsultaBuro  == null){
                                this.casos[i].AutorizaConsultaBuro='No'
                            }else{
                                this.casos[i].AutorizaConsultaBuro='Si'
                            }
						} 
            this.$vs.loading.close('#casos > .con-vs-loading')
					}else {
            this.$vs.notify({
              title:'Ocurrio un error en ListaCasos',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
				}
			).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
			})
		},*/
    getSolicitudes(){
      let self=this
			var objRequestListaCasos = {
				strApiKey: this.key,
				strMetodo: 'ListaCasos',
			}
			this.$axios.post('/',objRequestListaCasos,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
			.then(
				response => {
					if(response.data.intEstatus == 0){
            this.casos= response.data.objContenido
            this.allcasos=this.casos
						for (var i = 0; i < this.casos.length; i++) {
							this.casos[i].MontoSolicitado= this.casos[i].MontoSolicitado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							for (var j = 0; j < this.destinos.length; j++) {
								if (this.destinos[j].Id == this.casos[i].Destino) {
										this.casos[i].DestinoNombre=(this.destinos[j].Nombre).toLowerCase()
								}
							}
							for (var k = 0; k < this.estatus.length; k++) {
								if (this.estatus[k].Id == this.casos[i].Estatus) {
										this.casos[i].EstatusNombre=(this.estatus[k].Nombre).toLowerCase()
								}
							}
						}
            this.$vs.loading.close('#casos > .con-vs-loading')
					}else {
            this.$vs.notify({
              title:'Ocurrio un error en ListaCasos',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
				}
			).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
			})
		},
    getCasosWidget(){
      let self=this
			var objRequestListaCasosWidget = {
				strApiKey: this.key,
				strMetodo: 'ListaCasosWidget',
        objParametros: {
           ApiKey:this.key
       }
			}
			this.$axios.post('/',objRequestListaCasosWidget,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
			.then(
				response => {
					if(response.data.intEstatus == 0){
            this.casos= response.data.objContenido
            this.allcasos=this.casos
						for (var i = 0; i < this.casos.length; i++) {
							this.casos[i].MontoSolicitado= this.casos[i].MontoSolicitado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							this.casos[i].StatusCaso=this.casos[i].StatusCaso
              this.casos[i].VersionOrigen=this.casos[i].VersionOrigen
              for (var j = 0; j < this.destinos.length; j++) {
								if (this.destinos[j].Id == this.casos[i].Destino) {
										this.casos[i].DestinoNombre=(this.destinos[j].Nombre).toLowerCase()
								}
							}
							for (var k = 0; k < this.estatus.length; k++) {
								if (this.estatus[k].Id == this.casos[i].Estatus) {
										this.casos[i].EstatusNombre=(this.estatus[k].Nombre).toLowerCase()
								}
							}
						}
            this.$vs.loading.close('#casos > .con-vs-loading')
					}else {
            this.$vs.notify({
              title:'Ocurrio un error en ListaCasos',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
				}
			).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
			})
		},
    exportToExcel () {
      import('@/vendor/Export2Excel').then(excel => {
        let items=[]
        for(let i=0;i<this.allcasos.length;i++){
          let itemTabla=[]
          itemTabla.Id=this.allcasos[i].Id
          itemTabla.BrokerNombre=this.allcasos[i].BrokerNombre
          itemTabla.Fecha=this.allcasos[i].Fecha
          itemTabla.SolicitanteNombre=this.allcasos[i].SolicitanteNombre
          itemTabla.Solicitante=this.allcasos[i].Solicitante
          itemTabla.Telefono=this.allcasos[i].SolicitanteTelefonoCelular
          itemTabla.DestinoNombre=this.allcasos[i].DestinoNombre
          itemTabla.EstatusNombre=this.allcasos[i].EstatusNombre
          itemTabla.MontoSolicitado='$ '+this.allcasos[i].MontoSolicitado
          items.push(itemTabla)
        }
        const list = items
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    clearFields () {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    },
    statusTabs(statusSisec){
        
    }
	}
}
</script>
<style lang="css" scoped>
.contact-bold{
  color: #4891ff;
  font-weight: 500;
}
 /*.vista{padding-top: 80px;}*/
.perfil-margin{
  padding-top: 80px;
}
.vs-input {
    padding: 0px;
    border-radius: 0 5px 5px 0 !important;}

.vs-input2 {
    padding: 0px;
    border-radius: 5px !important;
    border: none;
    max-width: 190px !important;
    margin-left: -30px;

    }
.vs-input3 {
    padding: 0px;
    border-radius:0 5px 5px 0 !important;
    border: none;
    margin-top: 10px;
    max-width: 180px !important;
    margin-left: -6px;

    }
    select{padding: 0.55rem !important;}
.alinear{
  margin-bottom: 10px;
}
.lupa {
    margin-top: 10px;
    border: none;
    padding: 6px;
    background: #fff;
    border-radius: 5px 0 0 5px;
        -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
    box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
    margin-left: 210px;
}

input.input-search.vs-table--search-input{
  /*padding: 12px !important;*/
}
 .vs-table--search-input {
     border: none !important;}
      

select#estatus.search-input{border: none !important;
}


.w-full{padding-top: 0 !important;}
.excel{
  float: right;
    margin-right: 20px;
      position: relative;
      top: -50px;
      font-weight: 600;
  }
  @media screen and (max-width:896px) {

    .navbar-custom .vs-con-items {
    padding-left: 0px;}


  .footer{
    margin-top: 0;
    padding-top: 10px;
    background-color: #fff;
  }  
  .vs-input{
    border: 1px solid rgba(0,0,0,.04);
  }
     .vs-input2,
  .lupa{
    margin-left: 0px;
    background-color: #fff !important;
    border: 1px solid rgba(0,0,0,.04);
  }
  select#estatus.search-input{
    border: 1px solid rgba(0,0,0,.04) !important;
    margin-left: auto;
  }
  .vs-input2,
  .vs-input3{
     max-width: 100% !important;
     width: 100%;
     background-color: #fff !important;
     border: 1px solid rgba(0,0,0,.04) ;
      }
      .vs-input3{
        border: 1px solid rgba(0,0,0,.04) !important;
      }
      .alinear-input{
        margin-right: auto;
        margin-left: auto;
      }

  div#casos{
padding: 0;
  }
    .col-md-2{
      width: 100%;
    }
  }
    @media screen and (max-width:656px) {
    .navbar-custom .vs-con-items {
    padding-left: 0px;}}
</style>
